import React from 'react';
import {
    UserDetailsContainer,
    MyProfileContainer,
    SalesContainer,
    ExtraContainer,
} from './UserDetails.styled';
import { useTranslation } from 'react-i18next';
import { logErrorToConsole } from 'src/utils/util';

const UserDetails = (props) => {
    const { officeLocation, salesStructure, isSideNavBar } = props;
    const { t } = useTranslation();

    return (
        <UserDetailsContainer id="user-details-sidebar" isSideNavBar={isSideNavBar}>
            <SalesContainer isSideNavBar={isSideNavBar}>
                {salesStructure?.slice(0, 1).map((item) => {
                    return (
                        <span key={item.salesForceId}>
                            {item.district}
                            <br />
                            <span>
                                {item.territory}
                                {salesStructure?.length > 1 && (
                                    <ExtraContainer
                                        onClick={() => {
                                            try {
                                                props.openProfileDialog();
                                            } catch (error) {
                                                logErrorToConsole(error);
                                            }
                                        }}
                                    >
                                        + {salesStructure.length - 1}{' '}
                                        {t('common.moreLabel')}
                                    </ExtraContainer>
                                )}
                            </span>
                        </span>
                    );
                })}
            </SalesContainer>
            <span id="userDetails-location-pii">{officeLocation}</span>
            <MyProfileContainer
                onClick={() => {
                    try {
                        props.openProfileDialog();
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
            >
                {t('common.myProfileLabel')}
            </MyProfileContainer>
        </UserDetailsContainer>
    );
};

export default UserDetails;
